/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import store from "../store/store"

export const getCurrentRoomData = (socket, newJoinerSocketId) => {
    const state = store.getState()
    const history = state.room.history
    const id = history[0].ID

    let currentRoomData = {
        id,
        newJoinerSocketId,
        history: state.room.history,
        centerGraph: state.centerGraph,
        enginesStack: state.user.engines,
        owner: state.room.roomCreator,
        roomId: state.room.roomId,
    }

    let roomName
    history.forEach((room) => {
        roomName = room.ID
        currentRoomData[roomName] = state[roomName]
    });
    
    socket.emit("currentroomdata", currentRoomData)
}